export default __webpack_public_path__ + "static/media/148.c34f565f.png";